// extracted by mini-css-extract-plugin
module.exports = {"h1":"PayKonnectIntro_h1__1gEgB","title":"PayKonnectIntro_title__tNZ8K","portfolioContainer":"PayKonnectIntro_portfolioContainer__3sw-H"};